/* eslint-disable camelcase */
import axios from 'axios';
import { useQuery } from 'react-query';

export type UseRevivalType = {
  reviveId: string;
  deadWarriorIds: Array<string> | [];
  potionId: string;
  token: string | undefined;
};

export const useConfirmTxn = ({
  reviveId,
  deadWarriorIds,
  potionId,
  token,
  txnHash,
}) => {
  const apiHost = process.env.NEXT_PUBLIC_API_HOST;
  let consumed_warrior_ids: number[] = [];
  if (deadWarriorIds.length) {
    consumed_warrior_ids = deadWarriorIds.map((str) => {
      return Number(str);
    });
  }
  const payload = {
    target_warrior_id: parseInt(reviveId, 10),
    potion_id: parseInt(potionId, 10),
    consumed_warrior_ids: consumed_warrior_ids,
    transaction_hash: txnHash,
  };
  return useQuery<any | undefined, Error>(
    ['confirmTrx'],
    async () => {
      const { data } = await axios({
        url: `${apiHost}/potions/confirm`,
        method: 'post',
        data: payload,
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      return data;
    },
    {
      enabled: !!txnHash,
      retry: 10, // rety since need to wait until confirmed
    }
  );
};
